<template>
  <v-alert type="error" class="mt-5">
    <slot />
    <code class="code">{{ errorMessage }}</code>
  </v-alert>
</template>

<script>
export default {
  name: "ErrorAlert",
  props: ["errorMessage"]
};
</script>

<style lang="sass" scoped>
.code
  display: block
  margin-top: 10px
  max-width: 100%
</style>
